import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

// ── Inline SVG Icons ──────────────────────────────────────────────────────────
const HouseIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#fff3e0"/>
    <polygon points="60,15 100,50 100,105 20,105 20,50" fill="#ff8f00"/>
    <rect x="45" y="70" width="30" height="35" fill="#5d4037"/>
    <rect x="75" y="55" width="18" height="18" rx="2" fill="#fff9c4"/>
    <rect x="27" y="55" width="18" height="18" rx="2" fill="#fff9c4"/>
    <polygon points="60,10 105,52 115,52 60,0 5,52 15,52" fill="#e65100"/>
  </svg>
);

const WorkIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#e8f5e9"/>
    <rect x="15" y="85" width="90" height="12" rx="4" fill="#388e3c"/>
    <rect x="52" y="40" width="16" height="48" rx="4" fill="#795548"/>
    <ellipse cx="60" cy="38" rx="28" ry="10" fill="#fdd835"/>
    <rect x="32" y="32" width="56" height="12" rx="6" fill="#f9a825"/>
  </svg>
);

const BroomIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#e3f2fd"/>
    <rect x="55" y="10" width="10" height="60" rx="5" fill="#795548" transform="rotate(20,60,40)"/>
    <ellipse cx="68" cy="88" rx="35" ry="18" fill="#42a5f5" transform="rotate(-20,68,88)"/>
    <ellipse cx="68" cy="88" rx="28" ry="12" fill="#1565c0" transform="rotate(-20,68,88)"/>
  </svg>
);

const FlameIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#fce4ec"/>
    <ellipse cx="60" cy="95" rx="35" ry="10" fill="#b0bec5"/>
    <rect x="30" y="70" width="60" height="28" rx="6" fill="#90a4ae"/>
    <path d="M60 20 C40 40 30 60 45 80 C50 65 55 60 60 55 C65 60 70 65 75 80 C90 60 80 40 60 20Z" fill="#ff7043"/>
    <path d="M60 40 C50 55 48 68 58 76 C60 65 62 60 60 40Z" fill="#ffcc02"/>
  </svg>
);

const WaterIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#e0f7fa"/>
    <path d="M60 15 C60 15 25 55 25 78 C25 98 41 110 60 110 C79 110 95 98 95 78 C95 55 60 15 60 15Z" fill="#0288d1"/>
    <path d="M60 35 C60 35 38 62 38 78 C38 92 48 102 60 102 C72 102 82 92 82 78 C82 62 60 35 60 35Z" fill="#4fc3f7"/>
  </svg>
);

const CoinIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#fffde7"/>
    <ellipse cx="50" cy="75" rx="30" ry="10" fill="#f9a825"/>
    <rect x="20" y="50" width="60" height="25" fill="#fdd835"/>
    <ellipse cx="50" cy="50" rx="30" ry="10" fill="#ffee58"/>
    <ellipse cx="72" cy="62" rx="22" ry="8" fill="#f57f17" transform="rotate(-15,72,62)"/>
    <rect x="50" y="42" width="44" height="20" fill="#fbc02d" transform="rotate(-15,72,52)"/>
    <ellipse cx="72" cy="42" rx="22" ry="8" fill="#fff176" transform="rotate(-15,72,42)"/>
  </svg>
);

const FarmerIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#f1f8e9"/>
    <circle cx="60" cy="30" r="18" fill="#ffcc80"/>
    <path d="M35 110 C35 75 85 75 85 110Z" fill="#388e3c"/>
    <rect x="15" y="75" width="90" height="8" rx="4" fill="#8d6e63"/>
    <path d="M20 75 Q35 50 50 65 Q60 40 70 60 Q85 45 100 75Z" fill="#66bb6a"/>
  </svg>
);

const RoadIcon = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="120" height="120" rx="12" fill="#f3e5f5"/>
    <path d="M10 110 L45 10 L75 10 L110 110Z" fill="#616161"/>
    <path d="M25 110 L52 10 L68 10 L95 110Z" fill="#757575"/>
    <rect x="55" y="25" width="10" height="15" rx="2" fill="#fff"/>
    <rect x="55" y="55" width="10" height="15" rx="2" fill="#fff"/>
    <rect x="55" y="85" width="10" height="15" rx="2" fill="#fff"/>
    <path d="M5 95 Q20 85 35 95 Q50 105 65 95" fill="none" stroke="#66bb6a" strokeWidth="6"/>
    <path d="M75 90 Q90 80 105 90" fill="none" stroke="#66bb6a" strokeWidth="6"/>
  </svg>
);

// ── Data ──────────────────────────────────────────────────────────────────────
const schemeList = [
  {
    id: 1,
    label: 'मोदी आवास घरकुल योजना',
    englishLabel: 'Modi Awas Gharkul Yojana',
    lastUpdated: 'शुक्रवार, 12 एप्रिल 2024, 10:00:00 AM',
    englishLastUpdated: 'Friday, 12 April 2024, 10:00:00 AM',
    icon: HouseIcon,
    iconBg: '#fff3e0',
    content: [
      { id: 1, type: 'text', text: 'प्रधानमंत्री आवास योजना (ग्रामीण) ही भारत सरकारची महत्त्वाकांक्षी योजना असून या योजनेंतर्गत ग्रामीण भागातील गरजू व बेघर कुटुंबांना पक्के घर बांधण्यासाठी आर्थिक सहाय्य दिले जाते. मैदानी भागात रु. १,२०,००० व डोंगराळ/ईशान्य भागात रु. १,३०,००० अनुदान दिले जाते.', englishText: 'Pradhan Mantri Awas Yojana (Gramin) is an ambitious scheme by the Government of India, providing financial assistance to needy and homeless families in rural areas to construct pucca houses. A grant of Rs. 1,20,000 is given in plain areas and Rs. 1,30,000 in hilly/northeastern areas.' },
      { id: 2, type: 'text', text: 'SECC-2011 सर्वेक्षणानुसार पात्र लाभार्थ्यांची निवड ग्रामसभेमार्फत केली जाते. घराचे क्षेत्रफळ किमान २५ चौ.मी. असावे. शौचालय बांधकामासाठी SBM(G) अंतर्गत रु. १२,००० अतिरिक्त मिळतात.', englishText: 'Eligible beneficiaries are selected by the Gram Sabha based on the SECC-2011 survey. The house area must be at least 25 sq.m. An additional Rs. 12,000 is provided under SBM(G) for toilet construction.' },
      { id: 3, type: 'header', text: 'योग्यता शर्त:', englishText: 'Eligibility Criteria:' },
      { id: 4, type: 'text', text: '१. SECC-2011 यादीत नाव असणे आवश्यक आहे.', englishText: '1. Name must be present in the SECC-2011 list.' },
      { id: 5, type: 'text', text: '२. लाभार्थी कुटुंबाकडे पक्के घर नसावे किंवा घर कच्चे/जीर्ण असावे.', englishText: '2. The beneficiary family should not own a pucca house or the existing house must be kutcha/dilapidated.' },
      { id: 6, type: 'text', text: '३. कुटुंबातील कोणीही सरकारी नोकर नसावे व आयकर भरणारे नसावे.', englishText: '3. No family member should be a government employee or income tax payer.' },
      { id: 7, type: 'header', text: 'सहाय्य राशी:', englishText: 'Assistance Amount:' },
      { id: 8, type: 'text', text: 'मैदानी जिल्ह्यांसाठी रु. १,२०,००० | डोंगराळ/ईशान्य राज्ये रु. १,३०,००० | MGNREGS मजुरी ९०/९५ दिवस | शौचालयासाठी रु. १२,०००.', englishText: 'Rs. 1,20,000 for plain districts | Rs. 1,30,000 for hilly/NE states | MGNREGS wage for 90/95 days | Rs. 12,000 for toilet.' },
      { id: 9, type: 'header', text: 'अर्ज प्रक्रिया:', englishText: 'Application Process:' },
      { id: 10, type: 'text', text: '१. ग्रामसेवकाकडे अर्ज करावा. ग्रामसभेत नाव मंजूर झाल्यावर AwaasSoft पोर्टलवर नोंदणी होते.', englishText: '1. Apply with the Gram Sevak. Once approved in the Gram Sabha, registration is done on the AwaasSoft portal.' },
      { id: 11, type: 'text', text: '२. बांधकाम टप्प्याटप्प्याने होते; प्रत्येक टप्प्यावर जिओ-टॅग फोटो अपलोड करणे आवश्यक.', englishText: '2. Construction happens in stages; a geo-tagged photo must be uploaded at each stage.' },
      { id: 12, type: 'header', text: 'आवश्यक कागदपत्रे:', englishText: 'Required Documents:' },
      { id: 13, type: 'text', text: 'आधार कार्ड | बँक पासबुक | SECC यादीतील नाव | रहिवास दाखला | जॉब कार्ड (MGNREGS).', englishText: 'Aadhaar Card | Bank Passbook | Name in SECC list | Domicile Certificate | Job Card (MGNREGS).' },
    ],
  },
  {
    id: 2,
    label: 'महात्मा गांधी NREGS',
    englishLabel: 'Mahatma Gandhi NREGS',
    lastUpdated: 'सोमवार, 1 एप्रिल 2024, 09:00:00 AM',
    englishLastUpdated: 'Monday, 1 April 2024, 09:00:00 AM',
    icon: WorkIcon,
    iconBg: '#e8f5e9',
    content: [
      { id: 1, type: 'text', text: 'महात्मा गांधी राष्ट्रीय ग्रामीण रोजगार हमी योजना (MGNREGS) - ग्रामीण कुटुंबातील प्रत्येक प्रौढ सदस्यास वर्षातून १०० दिवस हमीशीर रोजगार दिला जातो. कामाची मागणी केल्यावर १५ दिवसांत काम देणे बंधनकारक आहे.', englishText: 'Mahatma Gandhi National Rural Employment Guarantee Scheme (MGNREGS) - Provides 100 days of guaranteed wage employment in a financial year to every rural household whose adult members volunteer to do unskilled manual work. Work must be provided within 15 days of demand.' },
      { id: 2, type: 'text', text: 'जॉब कार्डधारक कुटुंबास मागणीनुसार रोजगार न मिळाल्यास बेरोजगारी भत्ता देय आहे. महिला सहभाग किमान ३३% असणे अनिवार्य.', englishText: 'Unemployment allowance is payable if employment is not provided within 15 days. Minimum 33% participation of women is mandatory.' },
      { id: 3, type: 'header', text: 'पात्रता:', englishText: 'Eligibility:' },
      { id: 4, type: 'text', text: '१. ग्रामीण भागातील १८ वर्षांवरील कोणताही प्रौढ नागरिक अर्ज करू शकतो.', englishText: '1. Any adult citizen above 18 years residing in rural areas can apply.' },
      { id: 5, type: 'text', text: '२. अकुशल शारीरिक कामासाठी तयारी असणे आवश्यक.', englishText: '2. Must be willing to do unskilled manual work.' },
      { id: 6, type: 'header', text: 'कामांचे प्रकार:', englishText: 'Types of Works:' },
      { id: 7, type: 'text', text: 'शेत बांध, नाला खोलीकरण, वृक्षारोपण, रस्ते बांधकाम, विहीर, शेततळे, आवास योजना मजुरी, सिंचन कालवे.', englishText: 'Farm bunding, desilting of nullahs, plantation, road construction, wells, farm ponds, housing scheme labor, irrigation canals.' },
      { id: 8, type: 'header', text: 'अर्ज प्रक्रिया:', englishText: 'Application Process:' },
      { id: 9, type: 'text', text: 'ग्रामपंचायतीत जॉब कार्डसाठी अर्ज करावा. आधार कार्ड व फोटो सोबत द्यावा. जॉब कार्ड मिळाल्यावर कामाची मागणी लेखी/तोंडी करता येते.', englishText: 'Apply for a Job Card at the Gram Panchayat. Submit Aadhaar card and photo. Work can be demanded in writing or verbally once the Job Card is issued.' },
    ],
  },
  {
    id: 3,
    label: 'स्वच्छ भारत मिशन (ग्रामीण)',
    englishLabel: 'Swachh Bharat Mission (Gramin)',
    lastUpdated: 'बुधवार, 10 जानेवारी 2024, 11:30:00 AM',
    englishLastUpdated: 'Wednesday, 10 January 2024, 11:30:00 AM',
    icon: BroomIcon,
    iconBg: '#e3f2fd',
    content: [
      { id: 1, type: 'text', text: 'स्वच्छ भारत मिशन (ग्रामीण) टप्पा-२ (२०२०-२५) - ODF Plus गावे निर्माण करणे हे उद्दिष्ट आहे. घनकचरा व सांडपाणी व्यवस्थापन, प्लास्टिकमुक्त गाव व गोबरधन योजनेचा यात समावेश आहे.', englishText: 'Swachh Bharat Mission (Gramin) Phase-2 (2020-25) - The goal is to create ODF Plus villages. It includes solid and liquid waste management, plastic-free villages, and the GOBAR-Dhan scheme.' },
      { id: 2, type: 'header', text: 'शौचालय अनुदान:', englishText: 'Toilet Grant:' },
      { id: 3, type: 'text', text: 'वैयक्तिक शौचालय बांधकामासाठी रु. १२,००० प्रोत्साहन अनुदान (केंद्र ७५% + राज्य २५%). लाभार्थ्याने आधी स्वखर्चाने बांधल्यानंतर रक्कम DBT द्वारे मिळते.', englishText: 'Rs. 12,000 incentive grant for individual household latrine construction (Center 75% + State 25%). The amount is disbursed via DBT after the beneficiary completes construction at their own expense.' },
      { id: 4, type: 'header', text: 'ODF Plus घटक:', englishText: 'ODF Plus Components:' },
      { id: 5, type: 'text', text: '१. घनकचरा व्यवस्थापन - सोर्स सेग्रिगेशन, कंपोस्टिंग.', englishText: '1. Solid Waste Management - Source segregation, composting.' },
      { id: 6, type: 'text', text: '२. सांडपाणी व्यवस्थापन - सोकपिट, नाले.', englishText: '2. Liquid Waste Management - Soak pits, drains.' },
      { id: 7, type: 'text', text: '३. गोबरधन - शेण व जैव कचऱ्यापासून बायोगॅस.', englishText: '3. GOBAR-Dhan - Biogas from dung and bio-waste.' },
      { id: 8, type: 'header', text: 'आवश्यक कागदपत्रे:', englishText: 'Required Documents:' },
      { id: 9, type: 'text', text: 'आधार कार्ड | बँक खाते | रहिवास दाखला | शौचालय नसल्याचे ग्रामपंचायत प्रमाणपत्र.', englishText: 'Aadhaar Card | Bank Account | Domicile Certificate | Gram Panchayat certificate stating no existing toilet.' },
    ],
  },
  {
    id: 4,
    label: 'प्रधानमंत्री उज्ज्वला योजना',
    englishLabel: 'Pradhan Mantri Ujjwala Yojana',
    lastUpdated: 'गुरुवार, 22 फेब्रुवारी 2024, 02:00:00 PM',
    englishLastUpdated: 'Thursday, 22 February 2024, 02:00:00 PM',
    icon: FlameIcon,
    iconBg: '#fce4ec',
    content: [
      { id: 1, type: 'text', text: 'प्रधानमंत्री उज्ज्वला योजना (PMUY) - BPL व वंचित कुटुंबातील महिलांना मोफत LPG गॅस जोडणी, पहिला सिलेंडर व चूल (stove) विनामूल्य उपलब्ध केली जाते. धुरामुक्त स्वयंपाकघर हे या योजनेचे ध्येय आहे.', englishText: 'Pradhan Mantri Ujjwala Yojana (PMUY) - Provides free LPG gas connections, first cylinder, and stove to women from BPL and deprived households. A smoke-free kitchen is the goal of this scheme.' },
      { id: 2, type: 'header', text: 'पात्रता:', englishText: 'Eligibility:' },
      { id: 3, type: 'text', text: '१. दारिद्र्यरेषेखालील (BPL) कुटुंबातील महिला.', englishText: '1. Women from Below Poverty Line (BPL) families.' },
      { id: 4, type: 'text', text: '२. SC/ST, PMAY, MGNREGS जॉब कार्डधारक, वनवासी, बेटे रहिवासी महिला.', englishText: '2. SC/ST, PMAY, MGNREGS job card holders, forest dwellers, island resident women.' },
      { id: 5, type: 'text', text: '३. उज्ज्वला २.० - स्थलांतरित लाभार्थ्यांना पत्त्याचे पुरावे न लागता स्वयं-घोषणा पत्राद्वारे जोडणी.', englishText: '3. Ujjwala 2.0 - Connection for migrant beneficiaries through self-declaration without requiring address proof.' },
      { id: 6, type: 'header', text: 'लाभ:', englishText: 'Benefits:' },
      { id: 7, type: 'text', text: 'मोफत LPG जोडणी | पहिला सिलेंडर मोफत | चूल मोफत | EMI सुविधेने पुढील सिलेंडर.', englishText: 'Free LPG connection | First cylinder free | Free stove | EMI facility for subsequent cylinders.' },
      { id: 8, type: 'header', text: 'अर्ज प्रक्रिया:', englishText: 'Application Process:' },
      { id: 9, type: 'text', text: 'जवळच्या LPG वितरकाकडे KYC फॉर्म भरावा. आधार कार्ड, BPL कार्ड, बँक पासबुक व फोटो सोबत द्यावा.', englishText: 'Fill out the KYC form at the nearest LPG distributor. Submit Aadhaar Card, BPL Card, Bank Passbook, and a photo.' },
    ],
  },
  {
    id: 5,
    label: 'जल जीवन मिशन',
    englishLabel: 'Jal Jeevan Mission',
    lastUpdated: 'शुक्रवार, 5 एप्रिल 2024, 10:00:00 AM',
    englishLastUpdated: 'Friday, 5 April 2024, 10:00:00 AM',
    icon: WaterIcon,
    iconBg: '#e0f7fa',
    content: [
      { id: 1, type: 'text', text: 'जल जीवन मिशन (JJM) - प्रत्येक ग्रामीण कुटुंबास नळ जलजोडणी (FHTC) द्वारे शुद्ध व पुरेसे पिण्याचे पाणी उपलब्ध करण्याचे उद्दिष्ट. दैनंदिन ५५ लिटर प्रतिव्यक्ती पाणी हे मानक आहे.', englishText: 'Jal Jeevan Mission (JJM) - Aims to provide safe and adequate drinking water through Functional Household Tap Connections (FHTC) to every rural household. The standard is 55 liters per capita per day.' },
      { id: 2, type: 'header', text: 'ग्राम कृती योजना (VAP):', englishText: 'Village Action Plan (VAP):' },
      { id: 3, type: 'text', text: 'प्रत्येक गावात ग्राम पाणी व स्वच्छता समिती (VWSC) स्थापन करणे अनिवार्य आहे. VWSC पाणी पुरवठा व्यवस्था चालवते, देखभाल करते.', englishText: 'Establishment of a Village Water and Sanitation Committee (VWSC) is mandatory in every village. VWSC operates and maintains the water supply system.' },
      { id: 4, type: 'header', text: 'पाणी गुणवत्ता:', englishText: 'Water Quality:' },
      { id: 5, type: 'text', text: 'गावातील ५ महिलांना पाणी चाचणी किट (FTK) वापराचे प्रशिक्षण दिले जाते. नियमित गुणवत्ता तपासणी बंधनकारक.', englishText: '5 women in the village are trained to use Field Test Kits (FTK). Regular quality testing is mandatory.' },
      { id: 6, type: 'header', text: 'लाभार्थी योगदान:', englishText: 'Beneficiary Contribution:' },
      { id: 7, type: 'text', text: 'ग्रामपंचायत व VWSC ने जल दर आकारणी करणे आवश्यक. SC/ST वस्त्यांना प्राधान्य. कनेक्शन विनामूल्य.', englishText: 'Gram Panchayat and VWSC must levy water charges. Priority to SC/ST habitations. Connections are provided free of cost.' },
    ],
  },
  {
    id: 6,
    label: 'अटल पेन्शन योजना',
    englishLabel: 'Atal Pension Yojana',
    lastUpdated: 'मंगळवार, 19 मार्च 2024, 03:45:00 PM',
    englishLastUpdated: 'Tuesday, 19 March 2024, 03:45:00 PM',
    icon: CoinIcon,
    iconBg: '#fffde7',
    content: [
      { id: 1, type: 'text', text: 'अटल पेन्शन योजना (APY) - असंघटित क्षेत्रातील कामगारांसाठी निवृत्तीवेतन सुरक्षा. वयाच्या ६० व्या वर्षानंतर रु. १,०००  ते रु. ५,००० पर्यंत हमी मासिक पेन्शन दिली जाते.', englishText: 'Atal Pension Yojana (APY) - Pension security for workers in the unorganized sector. A guaranteed monthly pension ranging from Rs. 1,000 to Rs. 5,000 is provided after 60 years of age.' },
      { id: 2, type: 'header', text: 'पात्रता:', englishText: 'Eligibility:' },
      { id: 3, type: 'text', text: '१. वय १८ ते ४० वर्षांदरम्यान असावे.', englishText: '1. Age should be between 18 and 40 years.' },
      { id: 4, type: 'text', text: '२. बँक/पोस्ट ऑफिस बचत खाते असणे आवश्यक.', englishText: '2. Must have a bank/post office savings account.' },
      { id: 5, type: 'text', text: '३. कोणत्याही वैधानिक सामाजिक सुरक्षा योजनेचे लाभार्थी नसावे व आयकरदाते नसावे.', englishText: '3. Should not be a beneficiary of any statutory social security scheme and should not be an income taxpayer.' },
      { id: 6, type: 'header', text: 'सरकारी सह-योगदान:', englishText: 'Government Co-contribution:' },
      { id: 7, type: 'text', text: 'पात्र लाभार्थ्यांसाठी केंद्र शासनाने नोंदणीनंतर पहिल्या ५ वर्षांत ५०% योगदान (कमाल रु. १,०००/वर्ष) दिले.', englishText: 'The Central Government co-contributed 50% of the total contribution (max Rs. 1,000/year) for the first 5 years for eligible beneficiaries.' },
      { id: 8, type: 'header', text: 'नोंदणी प्रक्रिया:', englishText: 'Registration Process:' },
      { id: 9, type: 'text', text: 'बँक/पोस्ट ऑफिसमध्ये APY फॉर्म भरावा. आधार व मोबाईल क्रमांक द्यावा. मासिक हप्ता बँक खात्यातून auto-debit होतो.', englishText: 'Fill out the APY form at a bank/post office. Provide Aadhaar and mobile number. Monthly contributions are auto-debited from the bank account.' },
    ],
  },
  {
    id: 7,
    label: 'प्रधानमंत्री किसान सन्मान निधी',
    englishLabel: 'Pradhan Mantri Kisan Samman Nidhi',
    lastUpdated: 'सोमवार, 1 जानेवारी 2024, 08:00:00 AM',
    englishLastUpdated: 'Monday, 1 January 2024, 08:00:00 AM',
    icon: FarmerIcon,
    iconBg: '#f1f8e9',
    content: [
      { id: 1, type: 'text', text: 'प्रधानमंत्री किसान सन्मान निधी (PM-KISAN) - शेतकरी कुटुंबांना दरवर्षी रु. ६,००० रुपये तीन समान हप्त्यांत (प्रत्येकी रु. २,०००) थेट बँक खात्यात (DBT) जमा केले जातात.', englishText: 'Pradhan Mantri Kisan Samman Nidhi (PM-KISAN) - Farmer families receive Rs. 6,000 per year in three equal installments (Rs. 2,000 each) directly deposited into their bank accounts via DBT.' },
      { id: 2, type: 'header', text: 'पात्रता:', englishText: 'Eligibility:' },
      { id: 3, type: 'text', text: '१. जमीन धारण करणारे शेतकरी कुटुंब पात्र. जमीन नोंद ७/१२ उताऱ्यावर असावी.', englishText: '1. Landholding farmer families are eligible. Land records must be on the 7/12 extract.' },
      { id: 4, type: 'text', text: '२. संस्थात्मक जमीनधारक, सरकारी कर्मचारी, माजी/विद्यमान मंत्री, आयकरदाते अपात्र.', englishText: '2. Institutional landholders, government employees, former/current ministers, and income taxpayers are ineligible.' },
      { id: 5, type: 'header', text: 'नोंदणी प्रक्रिया:', englishText: 'Registration Process:' },
      { id: 6, type: 'text', text: 'ग्रामसेवकाकडे अर्ज करावा. आधार, बँक खाते, ७/१२ उतारा द्यावा. ग्रामसेवक PM-KISAN पोर्टलवर नोंद करतात.', englishText: 'Apply with the Gram Sevak. Provide Aadhaar, bank account details, and 7/12 extract. The Gram Sevak will register on the PM-KISAN portal.' },
      { id: 7, type: 'header', text: 'आवश्यक कागदपत्रे:', englishText: 'Required Documents:' },
      { id: 8, type: 'text', text: 'आधार कार्ड | बँक पासबुक | ७/१२ उतारा | ८-अ उतारा | मोबाईल क्रमांक.', englishText: 'Aadhaar Card | Bank Passbook | 7/12 Extract | 8-A Extract | Mobile Number.' },
    ],
  },
  {
    id: 8,
    label: 'मुख्यमंत्री ग्रामसडक योजना',
    englishLabel: 'Chief Minister Gram Sadak Yojana',
    lastUpdated: 'शनिवार, 16 मार्च 2024, 01:00:00 PM',
    englishLastUpdated: 'Saturday, 16 March 2024, 01:00:00 PM',
    icon: RoadIcon,
    iconBg: '#f3e5f5',
    content: [
      { id: 1, type: 'text', text: 'मुख्यमंत्री ग्रामसडक योजना - महाराष्ट्रातील ५०० पेक्षा कमी लोकसंख्येच्या वाड्या-वस्त्यांना मुख्य रस्त्याशी जोडणारे पक्के रस्ते बांधणे. PMGSY निकषांनुसार बांधकाम व देखभाल.', englishText: 'Chief Minister Gram Sadak Yojana - Constructing all-weather roads connecting hamlets with populations under 500 to main roads in Maharashtra. Construction and maintenance follow PMGSY norms.' },
      { id: 2, type: 'header', text: 'उद्दिष्ट:', englishText: 'Objective:' },
      { id: 3, type: 'text', text: 'महाराष्ट्रात २५,००० किमीपेक्षा अधिक ग्रामीण रस्त्यांचे जाळे विकसित करणे. वर्षभर वाहतुकीस योग्य रस्ते निर्माण करणे.', englishText: 'To develop a rural road network of over 25,000 km in Maharashtra and create all-weather roads.' },
      { id: 4, type: 'header', text: 'लाभार्थी:', englishText: 'Beneficiaries:' },
      { id: 5, type: 'text', text: 'ज्या वाड्या-वस्त्यांना अद्याप जोडरस्ता नाही अशा ग्रामीण वसाहती. आदिवासी व दुर्गम भागांना प्राधान्य.', englishText: 'Rural habitations lacking connecting roads. Priority is given to tribal and remote areas.' },
      { id: 6, type: 'header', text: 'अर्ज प्रक्रिया:', englishText: 'Application Process:' },
      { id: 7, type: 'text', text: 'ग्रामपंचायतीने ठराव करून जिल्हा परिषद / पंचायत समितीकडे प्रस्ताव सादर करावा. लोकसंख्या प्रमाणपत्र, नकाशा व अंदाजपत्रक सोबत जोडावे.', englishText: 'The Gram Panchayat should pass a resolution and submit a proposal to the Zilla Parishad/Panchayat Samiti, accompanied by a population certificate, map, and budget estimate.' },
    ],
  },
];

const ITEMS_PER_PAGE = 5;

// ── Component ─────────────────────────────────────────────────────────────────
const GramPanchayatScheme = () => {
  const { language } = useLanguage();
  const [selectedScheme, setSelectedScheme] = useState(schemeList[0]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = schemeList.filter((s) => {
    const labelToSearch = language === 'marathi' ? s.label : s.englishLabel;
    return labelToSearch.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // Translations
  const t = {
    title: language === 'marathi' ? 'ग्राम पंचायत योजना' : 'Gram Panchayat Schemes',
    search: language === 'marathi' ? 'Search:' : 'Search:',
    noSchemes: language === 'marathi' ? 'कोणतीही योजना सापडली नाही' : 'No schemes found',
    selectScheme: language === 'marathi' ? 'डाव्या बाजूने योजना निवडा' : 'Select a scheme from the left',
    lastUpdated: language === 'marathi' ? 'Last Updated: ' : 'Last Updated: ',
    prev: language === 'marathi' ? 'Previous' : 'Previous',
    next: language === 'marathi' ? 'Next' : 'Next'
  };

  const IconComponent = selectedScheme?.icon;

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex gap-4 items-start">

          {/* ── Left Sidebar ── */}
          <div className="w-72 flex-shrink-0">
            {/* Sidebar Header */}
            <div
              className="flex items-center gap-2 px-3 py-2.5 rounded-t-md font-semibold text-sm text-gray-800"
              style={{ backgroundColor: '#e8e8e8', borderLeft: '4px solid #f26b6b' }}
            >
              <span>🏘️</span>
              <span>{t.title}</span>
            </div>

            {/* Search Box */}
            <div className="bg-white border border-gray-200 px-3 py-2">
              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 whitespace-nowrap">{t.search}</label>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                  className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-400"
                />
              </div>
            </div>

            {/* Scheme List */}
            <div className="bg-white border border-gray-200 border-t-0 flex flex-col gap-1 p-2">
              {paginated.length === 0 ? (
                <p className="text-sm text-gray-500 text-center py-4">{t.noSchemes}</p>
              ) : (
                paginated.map((scheme) => {
                  const schemeLabel = language === 'marathi' ? scheme.label : scheme.englishLabel;
                  return (
                    <button
                      key={scheme.id}
                      onClick={() => setSelectedScheme(scheme)}
                      className={`w-full text-left text-sm font-medium px-3 py-2.5 rounded transition-all duration-150
                        ${selectedScheme?.id === scheme.id
                          ? 'text-white shadow-md'
                          : 'text-white hover:opacity-90'
                        }`}
                      style={{
                        backgroundColor:
                          selectedScheme?.id === scheme.id ? '#0891b2' : '#06b6d4',
                      }}
                    >
                      {schemeLabel}
                    </button>
                  );
                })
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="bg-white border border-gray-200 border-t-0 px-2 py-2 flex flex-wrap items-center gap-1">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.prev}
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`w-7 h-7 text-xs rounded border transition-colors
                      ${currentPage === page
                        ? 'text-white border-blue-500'
                        : 'border-gray-300 hover:bg-gray-50'
                      }`}
                    style={currentPage === page ? { backgroundColor: '#f26b6b', borderColor: '#f26b6b' } : {}}
                  >
                    {page}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.next}
                </button>
              </div>
            )}
          </div>

          {/* ── Right Content Panel ── */}
          <div className="flex-1 bg-white border border-gray-200 rounded-md shadow-sm min-h-96">
            {selectedScheme ? (
              <div className="p-5">
                {/* Title */}
                <h2
                  className="text-xl font-bold text-gray-800 border-b-2 pb-2 mb-1"
                  style={{ borderColor: '#f26b6b' }}
                >
                  {language === 'marathi' ? selectedScheme.label : selectedScheme.englishLabel}
                </h2>

                {/* Last Updated */}
                <p className="text-xs text-gray-500 text-right mb-5 italic">
                  {t.lastUpdated}{language === 'marathi' ? selectedScheme.lastUpdated : selectedScheme.englishLastUpdated}
                </p>

                {/* Scheme Image floated right + Content */}
                <div className="text-sm text-gray-700 leading-relaxed">
                  {/* Image — float right */}
                  <div
                    className="float-right ml-4 mb-3 w-36 h-36 rounded-xl shadow-md flex items-center justify-center p-3 flex-shrink-0"
                    style={{ backgroundColor: selectedScheme.iconBg, border: '2px solid #e0e0e0' }}
                  >
                    {IconComponent && <IconComponent />}
                  </div>

                  {/* Content Items */}
                  {selectedScheme.content.map((item) => {
                    const itemText = language === 'marathi' ? item.text : item.englishText;
                    return item.type === 'header' ? (
                      <h4 key={item.id} className="font-bold text-gray-800 mt-4 mb-1 text-sm">
                        {itemText}
                      </h4>
                    ) : (
                      <p key={item.id} className="mb-2 text-gray-700 text-sm leading-relaxed">
                        {itemText}
                      </p>
                    );
                  })}
                  <div className="clear-both" />
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center h-64 text-gray-400">
                <p>{t.selectScheme}</p>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default GramPanchayatScheme;
